<template>

    <div>
        <div class="alert alert-warning" v-if=" shift.id && !form.checked_out_time ">
            <b>Warning!</b> This visit is currently checked in. To check out this shift, set a Checked Out Time and click "Save".
        </div>
        <b-card>

            <form @submit.prevent="saveShift()"  :class="formClass">

                <b-row class="mb-2">

                    <b-col lg="6" class="my-1">
                        <user-role-search-dropdown 
                            type="provider" 
                            v-model="form.caregiver_id" 
                            :userpreselect="preselectedcaregiver" 
                            @keydown="form.clearError('caregiver_id')"
                            :disabled="isEditingCaregiver"
                        ></user-role-search-dropdown>
                    </b-col>
                    <b-col lg="6" class="my-1">

                        <user-role-search-dropdown
                            type="claimant"
                            v-model=" form.client_id "
                            :userpreselect=" preselectedclient "
                            @user="updateHospitalStayFlag"
                            :disabled="isEditingCaregiver"
                        ></user-role-search-dropdown>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-form-group label="Checked In Date &amp; Time" label-for="checked_in_time">
                            <b-row>
                                <b-col cols="7">
                                    <date-picker v-model="checked_in_date" placeholder="Date (MM/DD/YYYY)"></date-picker>
                                </b-col>
                                <b-col cols="5">
                                    <time-picker v-model="checked_in_time" placeholder="Time (Ex. 12:00 PM)"></time-picker>
                                </b-col>
                            </b-row>
                            <input-help :form="form" field="checked_in_time" text="Confirm the date &amp; time the shift was checked in to."></input-help>
                            <small class="form-text text-muted" v-if="show_12_hr_warning">
                              <span  class="text-warning">Warning this shift is at or exceeds 12 hrs. </span>
                            </small>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6">
                        <b-form-group label="Checked Out Date &amp; Time" label-for="checked_out_time">
                            <b-row>
                                <b-col cols="7">
                                    <date-picker v-model="checked_out_date" placeholder="Date (MM/DD/YYYY)"></date-picker>
                                </b-col>
                                <b-col cols="5">
                                    <time-picker v-model="checked_out_time" placeholder="Time (Ex. 12:00 PM)"></time-picker>
                                </b-col>
                            </b-row>
                            <input-help :form="form" field="checked_out_time" text="Confirm the date &amp; time the shift was checked out from."></input-help>
                            <small class="form-text text-muted" v-if="show_12_hr_warning">
                              <span  class="text-warning">Warning this shift is at or exceeds 12 hrs. </span>
                            </small>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6">
                        <b-form-group label="Provider Hourly Rate" label-for="caregiver_rate">
                            <b-form-input
                                    id="caregiver_rate"
                                    name="caregiver_rate"
                                    type="number"
                                    step="any"
                                    :disabled="!form.client_id || this.is_caregiver_mode"
                                    v-model="form.caregiver_rate"
                                    required
                                    @keydown="form.clearError('caregiver_rate')"
                                    @blur="runValidators"
                            >
                            </b-form-input>
                            <input-help :form="form" field="caregiver_rate" text=""></input-help>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6">
                        <b-form-group label="Shift Designation" label-for="hours_type">
                            <b-form-select
                                    id="hours_type"
                                    name="hours_type"
                                    v-model="form.hours_type"
                            >
                                <option value="default">Regular Shift</option>
                                <option value="holiday">Holiday</option>
                                <option value="overtime">Overtime</option>
                            </b-form-select>
                            <input-help :form="form" field="hours_type" text=""></input-help>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row lg="12" class="mt-2">
                    <b-col lg="6">
                        <b-form-group label="Did the client fall today?" label-class="h5">
                            <b-form-radio-group id="client_fall" v-model="form.client_fall" name="client_fall">
                                <b-form-radio value="1">Yes</b-form-radio>
                                <b-form-radio value="0">No</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6">
                        <b-form-group label="Was there a change in the client's condition today?" label-class="h5">
                            <b-form-radio-group id="client_condition" v-model="form.client_condition" name="client_condition">
                                <b-form-radio value="1">Improved</b-form-radio>
                                <b-form-radio value="-1">Declined</b-form-radio>
                                <b-form-radio value="0">No Change</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                
                <shift-hospital-stay-input
                    v-if="hospital_stays_enabled"
                    @hospital-stay-updated="updateHospitalStayFields"
                    :hospital_stays_enhanced_flow="hospital_stays_enhanced_flow"
                    :max="checked_out_date"
                    :hospital_stay="shift.hospital_stay"
                    :still_in_hospital="shift.still_in_hospital"
                    :from_date="shift.hospital_stay_from_date"
                    :to_date="shift.hospital_stay_to_date"
                />

                <b-row>
                    <b-col lg="12">
                        <h5>Activities Performed</h5>

                        <b-row class="mb-2" v-for="activity in activities" :key="activity.id">
                            <b-col cols="6">{{ activity.name }}</b-col>
                            <b-col cols="6">
                                <b-form-select name="test" v-model="form.activities[activity.id]">
                                    <option value="">---</option>

                                    <option v-for="option in activity.responses" :key="option.id" :value="option.name" v-text="option.name" />
                                </b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row v-if="shift.id">
                    <b-col sm="6">
                        <table class="table">
                            <thead>
                            <tr>
                                <th colspan="2">Check In EVV</th>
                            </tr>
                            </thead>
                            <tbody v-if="shift.checked_in_latitude || shift.checked_in_longitude">
                            <tr>
                                <th>Geocode</th>
                                <td>{{ shift.checked_in_latitude.slice(0,8) }},<br />{{ shift.checked_in_longitude.slice(0,8) }}</td>
                            </tr>
                            </tbody>
                            <tbody v-else-if="shift.checked_in_number">
                            <tr>
                                <th>Phone Number</th>
                                <td>{{ shift.checked_in_number }}</td>
                            </tr>
                            <tr v-if="shift.checked_in_expected_number">
                                <th>Expected Number</th>
                                <td>{{ shift.checked_in_expected_number }}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="2">No EVV data</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                    <b-col sm="6">
                        <table class="table">
                            <thead>
                            <tr>
                                <th colspan="2">Check Out EVV</th>
                            </tr>
                            </thead>
                            <tbody v-if="shift.checked_out_latitude || shift.checked_out_longitude">
                            <tr>
                                <th>Geocode</th>
                                <td>{{ shift.checked_out_latitude.slice(0,8) }},<br />{{ shift.checked_out_longitude.slice(0,8) }}</td>
                            </tr>
                            </tbody>
                            <tbody v-else-if="shift.checked_out_number">
                            <tr>
                                <th>Phone Number</th>
                                <td>{{ shift.checked_out_number }}</td>
                            </tr>
                            <tr v-if="shift.checked_out_expected_number">
                                <th>Expected Number</th>
                                <td>{{ shift.checked_out_expected_number }}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="2">No EVV data</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12">
                        <b-form-group label="Additional Comments" label-class="h5">
                            <b-textarea id="caregiver_comments" v-model="form.caregiver_comments" rows="4"></b-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>

                    <b-col lg="12" v-if="!shift.readOnly">
                        <i v-show="savingShift" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        <span v-if="!deleted">
                            <!--<b-button variant="success" type="button" @click="saveAndConfirm()" v-if="status === 'WAITING_FOR_CONFIRMATION'">Save &amp; Confirm</b-button>-->
                            <b-button variant="success" type="submit" :disabled="savingShift">Save Visit</b-button>
                            <!--<b-button variant="primary" type="button" :href="'/business/shifts/' + shift.id + '/duplicate'" v-if="shift.id"><i class="fa fa-copy"></i> Duplicate to a New Shift</b-button>-->
                            <!--<b-button variant="danger" type="button" @click="unconfirm()" v-if="status !== 'WAITING_FOR_CONFIRMATION'">Unconfirm</b-button>-->
                            <span v-if="!this.is_caregiver_mode">
                                <b-button :disabled="savingShift" variant="danger" type="button" @click="deleteShift()" v-if="shift.id"><i class="fa fa-times"></i> Delete Visit</b-button>
                            </span>
                        </span>
                        <b-button variant="secondary" :href="backToVisitHistoryURL"><i class="fa fa-backward"></i> Return to Visit History</b-button>
                    </b-col>
                    <b-col lg="12" v-else>
                        <b-button variant="info" disabled><i class="fa fa-lock"></i> This Visit is Locked For Modification</b-button>
                        <i v-show="savingShift" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        <b-button :disabled="savingShift" variant="success" @click="adminOverride()">Admin Override: Save Anyways</b-button>
                        <!--<b-button variant="primary" type="button" :href="'/business/shifts/' + shift.id + '/duplicate'" v-if="shift.id"><i class="fa fa-copy"></i> Duplicate to a New Shift</b-button>-->
                        <b-button variant="secondary" :href="backToVisitHistoryURL"><i class="fa fa-backward"></i> Return to Visit History</b-button>
                    </b-col>
                </b-row>
            </form>
        </b-card>
    </div>
</template>

<script>

    import FormatsNumbers from '../mixins/FormatsNumbers'
    import FormatsDates from "../mixins/FormatsDates";
    import UsesRole from '../mixins/UsesRole'
    import moment from "moment/moment";
    import {forEach} from "lodash";

    export default {

        mixins: [ FormatsNumbers, UsesRole, FormatsDates ],

        props: {

            scopeduser : {

                type     : Object,
                default  : null,
                required : false
            },
            shift : {

                default(){ return {}; }
            },
            issues : {

                default(){ return []; }
            },
            caregiver    : {},
            client       : {},
            in_distance  : {},
            out_distance : {},
            activities   : Array,
            admin        : Number,
            carriers     : Array,
            is_caregiver_mode: Boolean,
        },
        data() {
            return {
                form: new Form({
                    client_id          : ( 'client_id' in this.shift ) ? this.shift.client_id : null,
                    caregiver_id       : ( 'caregiver_id' in this.shift ) ? this.shift.caregiver_id : null,
                    caregiver_comments : ( 'caregiver_comments' in this.shift ) ? this.shift.caregiver_comments : null,
                    checked_in_time    : ( 'checked_in_time' in this.shift ) ? this.shift.checked_in_time : null,
                    checked_out_time   : ( 'checked_out_time' in this.shift ) ? this.shift.checked_out_time : null,
                    hours_type         : ( 'hours_type' in this.shift ) ? this.shift.hours_type : 'default',
                    caregiver_rate     : ( 'caregiver_rate' in this.shift ) ? this.shift.caregiver_rate : '',
                    provider_fee       : ( 'provider_fee' in this.shift ) ? this.shift.provider_fee : '',
                    activities         : this.getActivities(),
                    issues             : [], // only used for creating shifts, modifying a shift's issues is handled immediately in the modal
                    override           : false,
                    client_fall        : ( 'client_fall' in this.shift ) ? this.shift.client_fall : 0,
                    client_condition   : ( 'client_condition' in this.shift ) ? this.shift.client_condition : 0,
                    hospital_stay      : ( 'hospital_stay' in this.shift) && (this.shift.hospital_stay)? 1 : 0,
                    still_in_hospital       : ( 'still_in_hospital' in this.shift) && (this.shift.still_in_hospital)? 1 : 0,
                    hospital_stay_from_date : null,
                    hospital_stay_to_date   : null,
                    total_hours        : null,  // only used for creating shifts, modifying a shift's total hours is handled immediately in the modal
                }),
                status               : (this.shift) ? this.shift.status : null,
                checked_in_time      : '',
                checked_in_date      : '',
                checked_out_time     : '',
                checked_out_date     : '',
                
                issueModal           : false,
                selectedIssue        : null,
                deleted              : false,
                allyPct              : 0.05,
                paymentType          : 'NONE',
                savingShift          : false,
                preselectedcaregiver : null,
                preselectedclient    : null,

                hospital_stays_enabled : false,
                hospital_stays_enhanced_flow : false,
                show_12_hr_warning: false,
            }
        },
        created(){

            if( this.scopeduser && this.scopeduser.role_type == 'client' ) this.preselectedclient = this.scopeduser;
            if( this.client && this.client.id ) this.preselectedclient = this.client;
            if( this.scopeduser && this.scopeduser.role_type == 'caregiver' ) this.preselectedcaregiver = this.scopeduser;
            if( this.caregiver && this.caregiver.id ) this.preselectedcaregiver = this.caregiver;
        },
        mounted() {
            console.debug("Role", this.role)
            // Do not check against id below to allow for shift duplication
            if( this.shift.checked_in_time ){

                let checkin           = moment.utc(this.shift.checked_in_time).local();
                let checkout          = (this.shift.checked_out_time) ? moment.utc(this.shift.checked_out_time).local() : null;
                this.checked_in_date  = checkin.format('MM/DD/YYYY');
                this.checked_in_time  = checkin.format('HH:mm');
                this.checked_out_date = (checkout) ? checkout.format('MM/DD/YYYY') : null;
                this.checked_out_time = (checkout) ? checkout.format('HH:mm') : null;
            } else {

                this.checked_in_date  = moment().format( 'MM/DD/YYYY' );
                this.checked_out_date = moment().format( 'MM/DD/YYYY' );
            }
        },
        computed: {
            // getUserId() {
            //   let params = (new URL(document.location)).searchParams;
            //   let id = params.get('scopedUser');
            //   if (_.isEmpty(id)) {
            //     return null;
            //   }
            //   return parseInt(id);
            // },
           hours(){
              let clockin = this.getClockedInMoment();
              let clockout = this.getClockedOutMoment();
              return   clockout.diff(clockin, 'hours',true);
            },
            hoursAreNegative() {
               let sign = Math.sign(this.hours);
               return sign === -1;
            },
            shiftIsOverTwelveHours() {
                let clockin = this.getClockedInMoment();
                let clockout = this.getClockedOutMoment();
                let diffInMinutes = clockout.diff(clockin, 'minutes');
                return diffInMinutes >= 720;
            },
            isOverTwentyFourHours(){
              return this.hours > 24;
            },
            title() {
                return (this.shift.id) ? 'Visit Details' : 'Create a Manual Visit';
            },
            formClass() {
                if (this.deleted) return 'deletedForm';
                return '';
            },
            totalRate() {
                if (this.allyFee === null) return null;
                let caregiverHourlyFloat = parseFloat(this.form.caregiver_rate);
                let providerHourlyFloat = parseFloat(this.form.provider_fee);
                let totalRate = caregiverHourlyFloat + providerHourlyFloat + parseFloat(this.allyFee);
                return totalRate.toFixed(2);
            },
            allyFee() {
                if (!parseFloat(this.form.caregiver_rate)) return null;
                let caregiverHourlyFloat = parseFloat(this.form.caregiver_rate);
                let providerHourlyFloat = parseFloat(this.form.provider_fee);
                let allyFee = (caregiverHourlyFloat + providerHourlyFloat) * parseFloat(this.allyPct);
                return allyFee.toFixed(2);
            },
            backToVisitHistoryURL() {
                if (this.role === 'carrier_manager') {
                    return `/${this.controller}/${this.claimantModel}/${this.form.client_id}#visits`;
                }
                return '/caregiver/visit-history';
            }
        },
        methods: {
            updateHospitalStayFlag(user) {

                this.hospital_stays_enabled = false;
                this.hospital_stays_enhanced_flow = false;

                if (user === null) {
                    this.updateHospitalStayFields(false);
                    return;
                }

                let clientCarrier = this.carriers.filter(c => c.id == user.ltc_carrier_id);

                clientCarrier = clientCarrier? clientCarrier[0] : false;

                if (clientCarrier) {
                    this.hospital_stays_enabled = clientCarrier.hospital_stays_enabled;
                    this.hospital_stays_enhanced_flow = clientCarrier.hospital_stays_enhanced_flow;
                }
                
                if (!this.hospital_stays_enabled) {
                    // RESET HOSPITAL STAY
                    this.updateHospitalStayFields(false);
                }
            },
            updateHospitalStayFields(emitted) {
                this.form.hospital_stay             = emitted? emitted.hospitalStay : 0;
                this.form.still_in_hospital         = emitted? emitted.stillInHospital : 0;
                this.form.hospital_stay_from_date   = emitted? emitted.fromDate : null;
                this.form.hospital_stay_to_date     = emitted? emitted.toDate : null;
            },
            createIssue() {
                this.selectedIssue = null;
                this.issueModal = true;
            },
            editIssue(issue) {
                this.selectedIssue = issue;
                this.issueModal = true;
            },
            getClockedInMoment() {
                return moment(this.checked_in_date + ' ' + this.checked_in_time, 'MM/DD/YYYY HH:mm');
            },
            currentTime(){
            let now = moment();
            return moment(now, 'MM/DD/YYYY HH:mm');
            },
            getClockedOutMoment() {
                return moment(this.checked_out_date + ' ' + this.checked_out_time, 'MM/DD/YYYY HH:mm');
            },
            getActivities() {
                let activities = [];
                let shiftActivities = this.shift.activities || [];
                let shiftActivity;
                for(let activity of this.activities) {
                    shiftActivity = shiftActivities.find(item => item.id === activity.id);
                    let value = (shiftActivity) ? shiftActivity.value : '';
                    activities[activity.id] = value;
                }
                return activities;
            },
            deleteShift() {
                if (!confirm('Are you sure you wish to delete this shift?')) {
                  return;
                }
                try {
                  this.savingShift = true;
                  let form = new Form();
                  form.del(`/${this.controller}/shifts/${this.shift.id}`)
                      .then(response => {
                        this.deleted = true;
                      });
                } finally {
                  this.savingShift = false;
                }
            },
            isEditingCaregiver() {
                if (this.props.shift.id) {
                    return true
                }

                return false
            },
            async saveShift() {
                try {
                await this.runValidators();

                  if (this.form.hasError()) {
                    alerts.addMessage('error', 'Please fix form errors.');
                    return;
                  }
                  this.savingShift = true;
                  this.form.checked_in_time = this.getClockedInMoment().format();
                  this.form.checked_out_time = this.getClockedOutMoment().format();
                  this.form.total_hours = this.hours;

                  let method = 'post';
                  let url = `/caregiver/shifts/store`;
                  if (this.shift.id) {
                    method = 'patch';
                    url += `/${this.shift.id}`;
                  } else {
                    this.form.issues = this.issues;
                  }

                  if (!this.form.hasError()) {
                    await this.form.submit(method, url);
                  }
                } finally {
                  this.savingShift = false;
                }
            },
            async adminOverride() {
                this.form.override = 1;
                return await this.saveShift();
            },
            async saveAndConfirm() {
                await this.saveShift();
                if (this.shift.id) {
                    let form = new Form();
                    form.post(`/${this.controller}/shifts/${this.shift.id}/confirm`)
                        .then(response => {
                            this.status = response.data.data.status;
                        });
                }
            },
            unconfirm() {
                if (this.shift.id) {
                    let form = new Form();
                    form.post(`/${this.controller}/shifts/${this.shift.id}/unconfirm`)
                        .then(response => {
                            this.status = response.data.data.status;
                        });
                }
            },
            validateTimeDifference(field) {
                this.$nextTick(function() {
                    let clockin = this.getClockedInMoment();
                    let clockout = this.getClockedOutMoment();
                    if (clockin.isValid() && clockout.isValid()) {
                     let rules = ['shiftIsOverTwelveHours', 'isFuture', 'overTwentyFourHours',  'checkOutIsBeforeCheckIn']
                     forEach(rules, (rule) => {
                       this.evaluateErrors(field, rule);
                     });
                   }
                });
          },
          evaluateErrors(field ,rule){
              switch (rule) {
                case 'shiftIsOverTwelveHours':
                    if(this.shiftIsOverTwelveHours){
                      if (field === 'checked_in_time' || field === 'checked_in_date') {
                       this.show_12_hr_warning = true;
                      } else {
                        this.show_12_hr_warning = true;
                      }
                    }else{
                      this.show_12_hr_warning = false;
                    }
                  break;
                case 'isFuture':
                  let isFuture = this.isFuture();
                   if(isFuture){
                     if (field === 'checked_in_time' || field === 'checked_in_date') {
                            this.form.addError('checked_in_time', 'The check-in date and time cannot be in the future.');
                            this.form.addError('checked_in_date', 'The check-in date and time cannot be in the future.');
                          } else {
                            this.form.addError('checked_out_time', 'The check-out date and time cannot be in the future.');
                            this.form.addError('checked_out_date', 'The check-out date and time cannot be in the future.');
                          }
                     }else{
                       let fieldError = this.form.getError();
                       if(fieldError === 'The check-in date and time cannot be in the future.'
                           || fieldError === 'The check-out date and time cannot be in the future.') {
                         this.form.clearError();
                     }
                   }
                  break;
                  case 'overTwentyFourHours':
                          if(this.isOverTwentyFourHours) {
                            if (field === 'checked_in_time' || field === 'checked_in_date') {
                              this.form.addError('checked_in_time', 'The check-in date and time cannot be 24 hrs or more than the check-out date and time.');
                              this.form.addError('checked_in_date', 'The check-in date and time cannot be 24 hrs or more than the check-out date and time.');
                            } else {
                              this.form.addError('checked_out_time', 'The check-out date and time cannot be 24 hrs or more than the check-in date and time.');
                              this.form.addError('checked_out_date', 'The check-out date and time cannot be 24 hrs or more than the check-in date and time.');
                            }
                          }else{
                             let fieldError = this.form.getError();
                             if(fieldError === 'The check-in date and time cannot be 24 hrs or more than the check-out date and time.'
                                 || fieldError === 'The check-out date and time cannot be 24 hrs or more than the check-in date and time.')
                             {
                               this.form.clearError();
                             }
                          }
                    break;
                case 'checkOutIsBeforeCheckIn':
                  if(this.hoursAreNegative) {
                    if (field === 'checked_in_time' || field === 'checked_in_date') {
                      this.form.addError('checked_in_time', 'The check-in date and time must be before the check-out date and time.');
                      this.form.addError('checked_in_date', 'The check-in date and time must be before the check-out date and time.');
                    } else {
                      this.form.addError('checked_out_time', 'The check-out date and time must be after the check-in date and time.');
                      this.form.addError('checked_out_date', 'The check-out date and time must be after the check-in date and time.');
                    }
                  }else{
                    let fieldError = this.form.getError();
                    if(fieldError === 'The check-out date and time must be after the check-in date and time.'
                        || fieldError === 'The check-in date and time must be before the check-out date and time.')
                    {
                      this.form.clearError();
                    }
                  }
                  break;
                default:
                  return false;
              }

          },
        async runValidators(){
            this.form.clearError();
            this.validateTimeDifference('checked_in_date');
            this.validateTimeDifference('checked_in_time');
            this.validateTimeDifference('checked_out_date');
            this.validateTimeDifference('checked_out_time');
            if (this.form.hasError()) {
              alerts.addMessage('error', 'Please fix form errors.');
              return false;
            }else{
              return true;
            }
          },
          isFuture(field){
              var clock
              if(field === 'checked_in_date' || field === 'checked_in_time'){
                 clock = this.getClockedInMoment();
              }else{
                clock = this.getClockedOutMoment()
              }
              let current = this.currentTime();
              return  moment(clock).isAfter(current);
          },
            loadCaregiverRates() {
                console.debug("Role", this.role)
                console.debug("Controller", this.controller)
                console.debug("URL", `/${this.controller}/${this.claimantModel}/${this.form.client_id}/${this.providerModel}/${this.form.caregiver_id}`)

                if( !this.form.caregiver_id || !this.form.client_id ) return;

                axios.get(`/${this.controller}/${this.claimantModel}/${this.form.client_id}/${this.providerModel}/${this.form.caregiver_id}`).then( response => {

                    if( response.data.pivot ){
                        this.form.caregiver_rate = response.data.pivot.caregiver_hourly_rate;
                        this.form.provider_fee   = response.data.pivot.provider_hourly_fee;
                    }

                    if (response.data.caregiver_rate) {
                        this.form.caregiver_rate = response.data.caregiver_rate
                    }
                });
            },
            loadAllyPctFromClient() {
                if (!this.form.client_id) return;
                axios.get(`/${this.controller}/${this.claimantModel}/${this.form.client_id}/payment_type`).then(response => {
                    this.allyPct = response.data.percentage_fee;
                    this.paymentType = response.data.payment_type;
                });
            },
        },
        watch: {
            checked_in_date(val, old) {

              this.validateTimeDifference('checked_in_date')
            },
            checked_in_time(val, old) {

              this.validateTimeDifference('checked_in_time')
            },
            checked_out_date(val, old) {

              this.validateTimeDifference('checked_out_dates')
            },
            checked_out_time(val, old) {

              this.validateTimeDifference('checked_out_time')
            },
            'form.client_id': function() {
                if (!this.shift.id) {
                    this.loadCaregiverRates();
                }
                // this.loadAllyPctFromClient();
            },
            'form.caregiver_id': function() {
                if (!this.shift.id) {
                    this.loadCaregiverRates();
                }
            }
        },
    }
</script>

<style>
    .deletedForm {
        opacity: 0.3;
    }
</style>
